/**
 * chatUIAction - Redux actions for chat UI state
 */

export const toggleSidebar = () => ({
  type: 'TOGGLE_SIDEBAR',
});

export const setSidebarCollapsed = (collapsed) => ({
  type: 'SET_SIDEBAR_COLLAPSED',
  payload: collapsed,
});

export const setPanelWidths = (chatWidth, documentWidth) => ({
  type: 'SET_PANEL_WIDTHS',
  payload: {
    chatWidth,
    documentWidth,
  },
});

export const openDocumentPanel = () => ({
  type: 'OPEN_DOCUMENT_PANEL',
});

export const closeDocumentPanel = () => ({
  type: 'CLOSE_DOCUMENT_PANEL',
});

export const setDocumentPanelVisible = (visible) => ({
  type: 'SET_DOCUMENT_PANEL_VISIBLE',
  payload: visible,
});

export const setMobileHistoryOpen = (open) => ({
  type: 'SET_MOBILE_HISTORY_OPEN',
  payload: open,
});
